const COPY_BUTTON_SELECTOR = '[data-blog-post-copy-link]'
const COPIED_RESET_MS = 2000

class BlogPostShare {
  static init () {
    const button = document.querySelector(COPY_BUTTON_SELECTOR)
    if (!button) return

    button.addEventListener('click', (event) => {
      event.preventDefault()
      BlogPostShare.copyLink(button)
    })
  }

  static copyLink (button) {
    const url = button.getAttribute('data-url')
    const onCopied = () => BlogPostShare.showCopied(button)

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(onCopied).catch(() => {
        BlogPostShare.fallbackCopy(url, onCopied)
      })
      return
    }

    BlogPostShare.fallbackCopy(url, onCopied)
  }

  static fallbackCopy (url, onCopied) {
    const input = document.createElement('input')
    input.value = url
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    onCopied()
  }

  static showCopied (button) {
    const label = button.querySelector('[data-blog-post-copy-label]')
    if (!label) return

    label.textContent = button.getAttribute('data-copied-label')
    button.setAttribute('aria-label', button.getAttribute('data-copied-label'))
    window.clearTimeout(button.copyTimeout)
    button.copyTimeout = window.setTimeout(() => {
      label.textContent = button.getAttribute('data-label')
      button.setAttribute('aria-label', button.getAttribute('data-label'))
    }, COPIED_RESET_MS)
  }
}

export default BlogPostShare
